import { connect } from 'react-redux';
import {
    showOrgSurveyLoader,
    fetchOrgSurveysCompare,
    onOrgSurveyCompareSelect,
    onToggleOrgSurveyDrawer,
    handleOrgSurveyRequestClose,
} from 'actions/OrgSurvey';
import Component from './Component';


export const mapStateToProps = ({ settings, orgSurveys, orgs }) => {
    const { width } = settings;
    const {
        loader,
        drawerState,
        alertMessage,
        showMessage,
        orgSurveyCompareList,
    } = orgSurveys;
    const {
        selectedOrg,
    } = orgs;
    return {
        width,
        loader,
        drawerState,
        alertMessage,
        showMessage,
        selectedOrg,
        orgSurveyCompareList,
    };
};
export default connect(mapStateToProps, {
    showOrgSurveyLoader,
    fetchOrgSurveysCompare,
    onOrgSurveyCompareSelect,
    onToggleOrgSurveyDrawer,
    handleOrgSurveyRequestClose,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/Container.js